// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2kEIp","label":"Completed_label__1wOx5"};